module.exports = __webpack_public_path__ + "static/img/0010-2未启用吉林市人民政府.eba4ad6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/0010-2未启用吉林市人民政府.jpg
// module id = /FB9
// module chunks = 0